import { useEffect, useState } from 'react';
import api from '~/services/api';
import useStore from '~/store';
import { reportError } from '~/utils/reportError';
import { Contract } from '../types/contratResponse';

const useFetchContract = (contractHashId: string, organizationId?: string) => {
  const [contract, setContract] = useState<Contract | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchContract = async () => {
    setLoading(true);
    const params = organizationId ? { organization_id: organizationId } : undefined;
    await api.v2
      ?.get(`/Contracts/${contractHashId}`, { params })
      .then((response) => {
        setContract(response.data.data);
      })
      .catch((error) => {
        console.error('Failed to fetch contract:', error);
        reportError('Erro ao buscar dados do contrato', error, {
          context: 'useFetchContract',
          contractHashId
        });
        useStore.getState().addToast({
          title: 'Erro',
          message: 'Erro ao buscar contrato. Por favor, tente novamente.',
          type: 'error'
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchContract();
  }, [contractHashId, organizationId]);

  return { contract, loading };
};

export default useFetchContract;
